var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappGrises(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #747474;\n        fill-rule: evenodd;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WA_Logo",
    "data-name": "WA Logo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M436.5,74.4C388.6,26.5,324.9,0,257.1,0,117.2,0,3.4,113.8,3.3,253.7c0,44.7,11.7,88.4,33.9,126.8L1.2,512l134.5-35.3c37.1,20.2,78.8,30.9,121.2,30.9h.1c139.8,0,253.7-113.8,253.7-253.7,0-67.8-26.3-131.6-74.2-179.5ZM257.1,464.7h0c-37.9,0-75-10.2-107.4-29.4l-7.7-4.6-79.8,20.9,21.3-77.8-5-8c-21.1-33.6-32.3-72.4-32.2-112.2,0-116.3,94.7-210.9,211-210.9s109.3,22,149.1,61.8c39.8,39.9,61.7,92.8,61.7,149.2-.2,116.5-94.8,211-211,211ZM372.7,306.8c-6.3-3.2-37.5-18.5-43.3-20.6s-10-3.2-14.3,3.2-16.4,20.6-20.1,24.9c-3.7,4.2-7.4,4.8-13.7,1.6-6.3-3.2-26.8-9.9-51-31.5-18.8-16.8-31.6-37.6-35.3-43.9-3.7-6.4-.4-9.8,2.8-12.9,2.9-2.8,6.3-7.4,9.5-11.1,3.2-3.7,4.2-6.3,6.4-10.6,2.1-4.2,1.1-7.9-.5-11.1-1.6-3.2-14.3-34.4-19.5-47.1-5.1-12.4-10.4-10.7-14.3-10.9-3.7-.2-7.9-.2-12.2-.2s-11.1,1.6-16.9,7.9c-5.8,6.4-22.2,21.7-22.2,52.9s22.7,61.4,25.9,65.6,44.7,68.3,108.3,95.7c15.1,6.5,26.9,10.4,36.1,13.4,15.2,4.8,29,4.1,39.9,2.5,12.2-1.8,37.5-15.3,42.8-30.1s5.3-27.5,3.7-30.1c-1.5-2.8-5.7-4.4-12.1-7.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappGrises);
export default __webpack_public_path__ + "static/media/whatsapp-grises.db0beab30845960b6215bec7ce764a28.svg";
export { ForwardRef as ReactComponent };